import React, {useCallback, useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {changePageTitle} from "../typescript/redux/actions";
import {Datatable} from "../index";
import {DocumentService} from "./document.service";
import {useNavigate} from "react-router-dom";

export function DocumentUpdateLogList() {

    let navigate = useNavigate();
    const [pageParams, setPageParams] = useState(null);
    const dispatch = useDispatch();

    const findAll = useCallback(async (number, size, sort, filter) => {
        const items = await DocumentService.findAllUpdateLogs(number, size, sort, filter);
        setPageParams({
            number: number,
            size: size,
            sort: sort,
            filter: filter,
            items: items
        });
    }, []);

    useEffect(() => {
        dispatch(changePageTitle("Logs de alterações nos documentos"));
        findAll(0, parseInt(process.env.REACT_APP_PAGE_SIZE), "id,asc", '').then();
    }, [dispatch, findAll]);

    const goBack = () => {
        navigate('/documents');
    }

    const headerOperations = [
        {color: () => "primary", onClick: goBack, label: () => 'Voltar'},
    ]

    return pageParams && (
        <Datatable data={pageParams.items.content} totalData={pageParams.items.totalElements}
                   dataColumnNames={['ID', 'Documento', 'Valor antigo', 'Valor novo', 'Multa antiga', 'Multa nova',
                       'Juros dia antigo', 'Juros dia novo', 'Desconto antigo', 'Desconto novo', 'Valor final antigo', 'Valor final novo', 'Usuário']}
                   dataColumns={['id', 'documentId', 'oldValor', 'newValor', 'oldMulta', 'newMulta',
                       'oldJurosDia', 'newJurosDia', 'oldDesconto', 'newDesconto', 'oldValorFinal', 'newValorFinal', 'created_by']}
                   dataTypes={['number', 'number', 'decimal', 'decimal', 'decimal', 'decimal', 'decimal', 'decimal', 'decimal', 'decimal', 'decimal', 'decimal', 'string']}
                   number={pageParams.number} size={pageParams.size} sort={pageParams.sort} filter={pageParams.filter}
                   findAll={findAll} headerOperations={headerOperations}/>
    );
}